// Globals
const tools = document.querySelector('.tools');


// =======================================================
// Search
// =======================================================

// Variables
const searchpage = document.querySelector('body.search');
const searchTool = tools.querySelector('#js-toolSearch');
const searchPopup = document.querySelector('.search-popup');
const searchInput = document.querySelector('#searchInput');
const searchClose = document.querySelector('.search-close');

if (!searchpage) {
    searchClose.setAttribute('tabindex', -1);
    searchInput.setAttribute('tabindex', -1);
}

// Event click
searchTool.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
    searchClose.setAttribute('tabindex', 0);
    searchInput.setAttribute('tabindex', 0);
})

if (searchPopup) {
    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.body.classList.remove('search-open');
            searchPopup.classList.add('hideX');
            searchPopup.classList.remove('showX');
            this.setAttribute('tabindex', -1);
            searchInput.setAttribute('tabindex', -1);
        })
    }
}


// =======================================================
// Profils
// =======================================================
// Variable
const profileBtn = document.querySelector('.js-profils__button');
const profileBtnMobile = document.querySelector('.js-profils__button--close');

!!profileBtn &&
profileBtn.addEventListener('click', function(){
    profileBtn.classList.toggle('profils__button--open');
    profileBtn.closest('.profils').querySelector('.profils__list').classList.toggle('profils__list--open');
})
document.addEventListener("click", (e) => {
    if (!profileBtn.contains(e.target)) {
        document.querySelector('.profils__list').classList.remove('profils__list--open');
        profileBtn.classList.remove('profils__button--open');
    } 
});

if(window.innerWidth > 960){
    profileBtnMobile.addEventListener('click',  function(){
        document.querySelector('.profils__list').classList.remove('profils__list--open');
        profileBtn.classList.remove('profils__button--open');
    })
}


// =======================================================
// Favorite
// =======================================================
// // Variable
// const favoriteBtn = tools.querySelector('#js-toolFavorite');
// // Event click
// if (favoriteBtn) {
//     !!favoriteBtn && favoriteBtn.addEventListener('click', function() {
//         favoriteBtn.closest('.header').querySelector('.tools-view #divFavorites').classList.toggle('show-list');
//     })
// }
